import React from "react";
import styles from "./Slidetab.module.scss";
import component1 from "img/genai/images/component1.png";

export const ShowSlideImg = ({
  slideIndex,
  selectedSlide,
  isPreviewOpen,
  singleSlideMode = false,
  currentModule,
  multipleModuleData = [],
}) => {
  // Filter signedUrls based on current module's sourceCombination
  const getFilteredSignedUrls = () => {
    if (!selectedSlide?.signedUrls) return [];

    if (singleSlideMode) {
      return [selectedSlide.signedUrls[0]].filter(Boolean);
    }

    // For multi-module creation, filter by current module's sourceCombination
    if (multipleModuleData.length > 0 && currentModule) {
      const currentModuleData = multipleModuleData[currentModule - 1];
      if (currentModuleData?.sourceCombination) {
        return selectedSlide.signedUrls.filter((signedUrl) =>
          currentModuleData.sourceCombination.includes(signedUrl.pageId),
        );
      }
    }

    // Default: return all signedUrls
    return selectedSlide.signedUrls;
  };

  const filteredSignedUrls = getFilteredSignedUrls();

  // Handle single slide mode - always show first slide
  const displaySlideIndex = singleSlideMode ? 0 : slideIndex;

  if (
    filteredSignedUrls.length === 0 ||
    displaySlideIndex >= filteredSignedUrls.length
  ) {
    return (
      <article className={styles.showcontetslide}>
        <p>No image available for this slide.</p>
      </article>
    );
  }

  const slideImage = filteredSignedUrls[displaySlideIndex]?.signedUrl;
  const preventContextMenu = (e) => e.preventDefault();

  return (
    <article
      className={`${styles.showcontetslide} ${isPreviewOpen ? styles.previewOpen : ""}`}
    >
      <img
        onContextMenu={preventContextMenu}
        className={styles.showcontetimg}
        src={slideImage}
        alt={`Slide ${displaySlideIndex + 1}`}
      />
    </article>
  );
};

export const ShowSlideImgNew = ({
  slideIndex,
  selectedSlide,
  isPreviewOpen,
  singleSlideMode = false,
  currentModule,
  multipleModuleData = [],
}) => {
  // Get the specific slide URL based on slideIndex
  const getCurrentSlideUrl = () => {
    if (!selectedSlide?.signedUrls || selectedSlide.signedUrls.length === 0) {
      return null;
    }

    // Ensure slideIndex is within bounds
    const index = Math.max(
      0,
      Math.min(slideIndex, selectedSlide.signedUrls.length - 1),
    );

    return selectedSlide.signedUrls[index]?.signedUrl;
  };

  const slideImage = getCurrentSlideUrl();

  const preventContextMenu = (e) => e.preventDefault();

  if (!slideImage) {
    return (
      <article className={styles.showcontetslide}>
        <p>No image available for slide {slideIndex + 1}.</p>
      </article>
    );
  }

  // Get slide number for display
  const slideNumber = slideIndex + 1;

  return (
    <article
      style={{ padding: 0 }}
      className={`${styles.showcontetslide} ${isPreviewOpen ? styles.previewOpen : ""}`}
    >
      <img
        onContextMenu={preventContextMenu}
        className={styles.showcontetimg}
        src={slideImage}
        alt={`Slide ${slideNumber}`}
      />
    </article>
  );
};
